// FILE: src/firebase.js

import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  serverTimestamp,
  updateDoc, // <--- ADD THIS IMPORT
} from 'firebase/firestore';
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from 'firebase/auth';

// Your Firebase configuration object
const firebaseConfig = {
  apiKey: 'AIzaSyC7PlMLKTDiK1aG3gNlgWRQ20tdWNCl_VM',
  authDomain: 'truemetric-cffb7.firebaseapp.com',
  projectId: 'truemetric-cffb7',
  storageBucket: 'truemetric-cffb7.appspot.com',
  messagingSenderId: '30715104344',
  appId: '1:30715104344:web:adbc2077f383ae7129ce2d',
  measurementId: 'G-6CWSBQ378G',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

/**
 * Creates or updates a user document in Firestore.
 * The 'user.uid' in this function refers to the TrueMetric Firebase Authentication UID.
 * The 'prolifiappUID' is an optional ID from your external Prolifiapp system.
 * @param {import('firebase/auth').User} user The Firebase Auth User object.
 * @param {string | null} prolifiappUID The UID from the Prolifiapp system, if available.
 */
const createUserDocument = async (user, prolifiappUID = null) => {
  const userDocRef = doc(db, 'users', user.uid); // Document ID is TrueMetric Firebase Auth UID
  const userDocSnap = await getDoc(userDocRef);

  const userDataToSet = {
    uid: user.uid, // This is the TrueMetric Firebase Auth UID
    email: user.email,
    clientIds: [], // Initialize with an empty array or assign clients as needed
    createdAt: serverTimestamp(),
  };

  if (prolifiappUID) {
    userDataToSet.prolifiappUID = prolifiappUID; // Add prolifiappUID if provided
  }

  if (!userDocSnap.exists()) {
    // If the document does not exist, create it with initial data
    await setDoc(userDocRef, userDataToSet);
    console.log(`[Firestore] New user document created for ${user.email} (Firebase UID: ${user.uid})`);
  } else {
    // If the document exists, check if prolifiappUID needs to be set or updated
    const existingData = userDocSnap.data();
    if (prolifiappUID && existingData.prolifiappUID !== prolifiappUID) {
      await updateDoc(userDocRef, { prolifiappUID });
      console.log(`[Firestore] Updated prolifiappUID for user ${user.email} (Firebase UID: ${user.uid})`);
    }
  }
};

// Listen for auth state changes (primarily for the web app where this firebase.js is used)
onAuthStateChanged(auth, (user) => {
  if (user) {
    // When a user signs in via TrueMetric's Firebase Auth (e.g., web app login),
    // we call createUserDocument. At this point, the prolifiappUID is typically
    // not directly known by the web app's Firebase Auth listener.
    createUserDocument(user);
  }
});

export { db, auth, signInWithEmailAndPassword, createUserWithEmailAndPassword, createUserDocument }; // <--- EXPORT createUserDocument